import { Injectable } from '@angular/core';
import { StoreService } from '@root/shared/service/store.service';
import _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class AuthorityService {

  private readonly key = 'permission_blacklist';

  constructor(private storeService: StoreService) { }

  getBlackList() {
    return this.storeService.getJSON(this.key, 2) || []
  }

  hasReadPermission(operate) {
    const blacklist = this.getBlackList();
    if (blacklist.find(p => p.title === operate && p.permission === 'read')) {
      return false;
    }
    return true;
  }

  hasWritePermission(operate) {
    const blacklist = this.getBlackList();
    if (blacklist.find(p => p.title === operate && p.permission === 'write')) {
      return false;
    }
    return true;
  }
}
